import _ from "lodash";
import React, { Component } from "react";
import { BaseComponent } from "BaseComponent";
import { connect } from "react-redux";
import { Field } from "redux-form";
import Pagination from "react-js-pagination";
import { searchUser, fetchUserList } from "DashboardUserAction";
import NoContent, { NO_USER } from "NoContent";
import { itemCount } from "Constants";
import UsersCell from "./userscell";
import LocaleStrings from "Languages";

class AssociatedUsers extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      selectedUsers: [],
      search: "",
      allCheck: false,
    };
  }

  componentDidMount() {
    var { initialValues } = this.props;

    if (
      initialValues &&
      initialValues.appuser_by_sponsoridfk &&
      initialValues.appuser_by_sponsoridfk.length > 0
    ) {
      var selected = [];
      _.map(initialValues.appuser_by_sponsoridfk, (item) => {
        item.checked = true;
        selected.push(item);
      });
      this.setState({ selectedUsers: selected });
      this.checkMatchArray(selected);
    }
  }

  // Here we are checking to user who are visiable on screen only
  selectAllUsers = () => {
    var state = this.state.allCheck;
    var { selectedUsers } = this.state;
    var allUsers = this.props.userList.data;
    var newSelectUser = [];
    var newSelectedUsers = [];

    if (state == false) {
      _.map(allUsers, (user) => {
        var checkUserExitOrNot = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === user.appuserid;
        });

        //Check if user is not exist in selected user that add
        if (checkUserExitOrNot.length == 0) {
          newSelectUser = { ...user, checked: true };
          selectedUsers = [...selectedUsers, newSelectUser];
        }
        this.checkMatchArray(selectedUsers);
        this.setState({ selectedUsers });
      });
      this.chaeckSelectedUserChanged(selectedUsers);
    } else {
      var leftUsers = selectedUsers;
      _.map(allUsers, (user) => {
        newSelectedUsers = _.filter(leftUsers, function (selusers) {
          return selusers.appuserid !== user.appuserid;
        });
        leftUsers = newSelectedUsers;

        this.checkMatchArray(leftUsers);
        this.setState({ selectedUsers: leftUsers });
      });
      this.chaeckSelectedUserChanged(leftUsers);
    }
  };

  selectionCallback = (user) => {
    var { selectedUsers } = this.state;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === user.appuserid;
    });
    if (index >= 0) {
      var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
        return selusers.appuserid !== user.appuserid;
      });
      this.checkMatchArray(newSelectedUsers);
      this.chaeckSelectedUserChanged(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    } else {
      var selectedUser = { ...user, checked: true };
      selectedUsers = [...selectedUsers, selectedUser];
      this.checkMatchArray(selectedUsers);
      this.chaeckSelectedUserChanged(selectedUsers);
      this.setState({ selectedUsers });
    }
  };

  onSearchUser = (event) => {
    var search = event.target.value;
    var pageNumber = 1;
    this.setState({ search, pageNumber });

    setTimeout(() => {
      this.paginationCallback(pageNumber);
    }, 500);
  };

  paginationCallback = (pageNumber) => {
    let { search, selectedUsers } = this.state;
    let { session } = this.props;

    if (search != "") {
      this.props.searchUser(session, search, pageNumber, (response) => {
        this.checkMatchArray(selectedUsers);
      });
    } else {
      this.props.fetchUserList(session, pageNumber, 0, (response) => {
        this.checkMatchArray(selectedUsers);
      });
    }
    this.setState({ ...this.state, pageNumber });
  };

  // This function is used to check or uncheck master check field
  checkMatchArray = (selectedUsers) => {
    setTimeout(() => {
      var userList = this.props.userList.data;
      var newArray = [];
      _.map(userList, (appUser) => {
        var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === appUser.appuserid;
        });

        // New
        if (newSelectedUsers && newSelectedUsers.length > 0) {
          // newArray = [...newArray, newSelectedUsers];
          newArray.push(newSelectedUsers[0]);
        }
      });

      // Check for all user selected or not according to that check or uncheck master check option
      if (newArray.length > 0 && newArray.length === userList.length) {
        this.setState({ allCheck: true });
      } else {
        this.setState({ allCheck: false });
      }
    }, 100);
  };

  // This function is used to update the hidden field permittedusers to enabled or disabled save button
  chaeckSelectedUserChanged = (selectedUsers) => {
    var permittedusers = "";

    if (selectedUsers.length > 0) {
      permittedusers = JSON.stringify(selectedUsers);
    }
    this.props.autofill("permittedusers", permittedusers);
  };

  renderUserList() {
    var { selectedUsers } = this.state;
    var users = this.props.userList.data;
    var cells = [];
    _.map(users, (appUser, index) => {
      var selected = selectedUsers.find(
        (curuser) => curuser.appuserid === appUser.appuserid
      );
      var checked = false;
      if (selected) {
        checked = selected.checked;
      }
      cells.push(
        <UsersCell
          key={appUser.appuserid}
          user={appUser}
          checked={checked}
          selectedusers={false}
          toggleSelection={this.selectionCallback}
        />
      );
    });
    return cells;
  }

  renderSelectedUserList() {
    var { selectedUsers } = this.state;
    var cells = [];
    _.map(selectedUsers, (appUser, index) => {
      var checked = false;
      cells.push(
        <UsersCell
          key={appUser.appuserid}
          user={appUser}
          checked={checked}
          selectedusers={true}
          removeFromSelected={this.selectionCallback}
        />
      );
    });
    return cells;
  }

  render() {
    var { userList } = this.props;
    var { selectedUsers } = this.state;
    var allListLeft = { padding: 0, borderRight: "1px solid #e6edf3" };
    var allListRight = { padding: 0 };

    if (
      userList &&
      userList.data &&
      userList.data.length < 11 &&
      selectedUsers.length > userList.data.length
    ) {
      var allListLeft = { padding: 0 };
      var allListRight = { padding: 0, borderLeft: "1px solid #e6edf3" };
    }

    return (
      <div>
        <div className="row">
          <div className="col-md-6" style={{ paddingLeft: 0 }}>
            <input
              className="form-control private-user-search"
              placeholder="Search....."
              type="search"
              value={this.state.search}
              onChange={this.onSearchUser}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6" style={allListLeft}>
            <h3>{LocaleStrings.sponsor_userlist}</h3>
            {this.props.userList.data && this.props.userList.count > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      <label className="checkcontainer">
                        <input
                          type="checkbox"
                          onChange={this.selectAllUsers}
                          checked={this.state.allCheck}
                        />
                        <span className="checkcheckmark" />
                      </label>
                    </th>
                    <th>{LocaleStrings.sponsor_th_name}</th>
                  </tr>
                </thead>
                <tbody>{this.renderUserList()}</tbody>
              </table>
            ) : (
              <NoContent contentType={NO_USER} />
            )}
            {this.props.userList.data &&
            this.props.userList.count > itemCount ? (
              <Pagination
                activePage={this.state.pageNumber}
                itemsCountPerPage={itemCount}
                totalItemsCount={this.props.userList.count}
                pageRangeDisplayed={4}
                onChange={this.paginationCallback}
              />
            ) : null}
          </div>
          <div className="col-md-6" style={allListRight}>
            <h3 style={{ paddingLeft: 5 }}>Permitted Users List</h3>
            {selectedUsers.length > 0 ? (
              <table className="table scrollable-table">
                <thead>
                  <tr>
                    <th>
                      <span>{LocaleStrings.sponsor_th_name}</span>
                      {selectedUsers.length > 0 ? (
                        <span className="pull-right">
                          {LocaleStrings.sponsor_th_total}{" "}
                          {selectedUsers.length}
                        </span>
                      ) : (
                        ""
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <div className="scroll-section">
                    {this.renderSelectedUserList()}
                  </div>
                </tbody>
              </table>
            ) : (
              <NoContent contentType={NO_USER} />
            )}
            <Field
              name="permittedusers"
              type="text"
              label=""
              placeholder=""
              component={this.renderHiddenFieldText}
              mandatory="false"
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    userList: state.dashboardUserList,
  };
}

export default connect(mapStateToProps, { searchUser, fetchUserList })(
  AssociatedUsers
);
